/* eslint-disable */
/* istanbul ignore file */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface exportFirmwareListState {
  isLoading: boolean
  loadingError: string | null
  exportFirmwareList: any
}

// Initial state of the slice
const initialState: exportFirmwareListState = {
  isLoading: true,
  loadingError: null,
  exportFirmwareList: null
}

// Slice to return from action
export const exportFirmwareListSlice = createSlice({
  name: 'exportFirmwareList',
  initialState,
  reducers: {
    exportFirmwareListLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        exportFirmwareList: []
      }
    },
    exportFirmwareListUpdateAction: (state, action: PayloadAction< any >) => {
      return {
        isLoading: false,
        loadingError: null,
        exportFirmwareList: action.payload
      }
    },
    exportFirmwareListErrorAction: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        isLoading: false,
        loadingError: action.payload,
        exportFirmwareList: null
      }
    }
  }
})

// Actions to export
export const {
  exportFirmwareListLoadingAction,
  exportFirmwareListUpdateAction,
  exportFirmwareListErrorAction
} = exportFirmwareListSlice.actions

export default exportFirmwareListSlice.reducer